import { render, staticRenderFns } from "./factoryDetail.vue?vue&type=template&id=2990e0cd&scoped=true"
import script from "./factoryDetail.vue?vue&type=script&lang=js"
export * from "./factoryDetail.vue?vue&type=script&lang=js"
import style0 from "./factoryDetail.vue?vue&type=style&index=0&id=2990e0cd&prod&lang=less&scoped=true"
import style1 from "./factoryDetail.vue?vue&type=style&index=1&id=2990e0cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990e0cd",
  null
  
)

export default component.exports